import type { MaybeRefOrGetter } from '@vueuse/shared'
import { useScrollLock as vueuseScrollLock } from '@vueuse/core'
import { onMounted, ref } from 'vue'

type ScrollLockElementType = MaybeRefOrGetter<HTMLElement | SVGElement | Window | Document | null | undefined>

export function useScrollLock(element: ScrollLockElementType = null, initialState?: boolean) {
    const document = ref<Document | null>(null)

    onMounted(async () => {
        if (!element) {
            document.value = window.document as unknown as Document
        }
    })

    const scrollLock = element ? vueuseScrollLock(element, initialState) : vueuseScrollLock(document, initialState)

    function disableScroll() {
        scrollLock.value = true
    }

    function enableScroll() {
        scrollLock.value = false
    }

    return {
        scrollLock,
        disableScroll,
        enableScroll,
    }
}
